function MtdYtdReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">MtdYtdReport</div>
      </>
    );
  }
  
  export default MtdYtdReport;